'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _antd = require('antd');

var _genericMaterialDefaults = require('../../../lib/genericMaterialDefaults');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FieldSelect(_ref) {
	var value = _ref.value,
	    _onChange = _ref.onChange,
	    moreSettings = _ref.moreSettings;

	return _react2.default.createElement(
		_antd.Select,
		{
			style: { marginRight: 30, width: '100%' },
			value: value,
			placeholder: 'Tipo do campo ',
			onChange: function onChange(e) {
				_onChange(e);
			}
		},
		_genericMaterialDefaults.types.map(function (row) {
			return _react2.default.createElement(
				_antd.Select.Option,
				{ value: row.value, key: row.value },
				row.name
			);
		}),
		moreSettings === true && _react2.default.createElement(
			_antd.Select.Option,
			{ value: 'moresettings' },
			'Configurar...'
		)
	);
}
exports.default = FieldSelect;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/components/genericMaterialAreas/ContentTree/FieldSelect.js
// module id = 1305
// module chunks = 0